<template>
<!--  <div class="row m-0 mt-md-5 mb-md-5">-->
  <div class="row m-0 mt-md-5 mb-md-5 m-auto" style="width: 88%">
    <div class="col-md-3">
      <div class="card-header text-white pt-5 pb-5 h3 animate__animated animate__slideInDown">关于我们</div>
      <div class="list-group p-0">
        <a href="/company" class="bg-light text-dark list-group-item list-group-item-action list-group-item-primary text-left animate__animated animate__slideInDown">中心简介</a>
        <a href="/train" class="bg-light text-dark list-group-item list-group-item-action list-group-item-primary text-left animate__animated animate__slideInDown">中心领导</a>
        <a href="/funcDep" class="bg-light font-weight-bold text-dark list-group-item list-group-item-action list-group-item-primary text-left animate__animated animate__slideInDown active">职能部门</a>
        <a href="/leadership" class="bg-light text-dark list-group-item list-group-item-action list-group-item-primary text-left animate__animated animate__slideInDown">领导讲话</a>
      </div>
    </div>
    <div class="col-md-9 animate__animated animate__slideInUp" style="min-height: 600px">
      <div class="text-left h3">职能部门</div>
      <div class="text-left mt-4">
        <table class="table table-hover table-sm table-borderless w-75 m-auto h5">
          <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                秘书处
              </div>
            </td>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                美术事业工作部
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                影视事业工作部
              </div>
            </td>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                艺术家培养培训部
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                科艺融合发展部
              </div>
            </td>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                国际学术交流工作部
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                音乐和演出事业工作部
              </div>
            </td>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                社会艺术考级工作部
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                民族艺术演播大厅
              </div>
            </td>
            <td>
              <div class="alert alert-dark m-0" role="alert">
                艺术市场开发部
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "funcDep"
}
</script>

<style scoped>
.div-center {
  margin: 0 auto;
}
td:first-child {
  width: 50%;
}
</style>